/**
 * Das Startbild: Mitspieler festlegen und die Partie beginnen.
 */
import type { SpielerVorgabe } from '../core/spiel'
import { SPIELERFARBEN } from '../core/spiel'
import { tonVorbereiten } from './klang'

export interface Aufstellung {
  readonly spieler: readonly SpielerVorgabe[]
  readonly saat: number
  readonly rundenlimit: number | null
}

const VORNAMEN = ['Anna', 'Bruno', 'Cem', 'Dana']

function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  klasse?: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const n = document.createElement(tag)
  if (klasse) n.className = klasse
  if (text !== undefined) n.textContent = text
  return n
}

export function zeigeStart(wurzel: HTMLElement, beginne: (a: Aufstellung) => void): void {
  let anzahl = 3
  let limit: number | null = 300
  const bots = [false, true, true, true]
  const namen = [...VORNAMEN]

  wurzel.replaceChildren()
  const seite = el('div', 'start')
  const karte = el('div', 'start-karte')
  seite.append(karte)
  wurzel.append(seite)

  const titel = el('h1', 'start-titel')
  titel.innerHTML = 'Fünf <b>Sterne</b>'
  karte.append(titel)
  karte.append(
    el(
      'p',
      'start-unter',
      'Grundstücke kaufen, Baugenehmigungen erwürfeln, Hotels hochziehen und ' +
        'Eingänge an die Straße setzen. Wer an einem fremden Eingang hält, ' +
        'übernachtet und zahlt. Wer nichts mehr hat, scheidet aus.',
    ),
  )

  const anzahlGruppe = el('div', 'feldgruppe')
  anzahlGruppe.append(el('label', undefined, 'Mitspieler'))
  const anzahlReihe = el('div', 'wahlreihe')
  anzahlGruppe.append(anzahlReihe)
  karte.append(anzahlGruppe)

  const listeGruppe = el('div', 'feldgruppe')
  listeGruppe.append(el('label', undefined, 'Wer spielt mit'))
  const liste = el('div', 'mitspieler')
  listeGruppe.append(liste)
  karte.append(listeGruppe)

  const limitGruppe = el('div', 'feldgruppe')
  limitGruppe.append(el('label', undefined, 'Partielänge'))
  const limitReihe = el('div', 'wahlreihe')
  limitGruppe.append(limitReihe)
  karte.append(limitGruppe)

  const los = el('button', 'knopf-gross', 'Partie beginnen')
  los.addEventListener('click', () => {
    // Ton darf erst aus einer Benutzeraktion heraus starten.
    tonVorbereiten()
    beginne({
      spieler: Array.from({ length: anzahl }, (_, i) => ({
        name: namen[i]!,
        farbe: SPIELERFARBEN[i]!,
        bot: bots[i]!,
      })),
      saat: Math.floor(Math.random() * 2 ** 30) + 1,
      rundenlimit: limit,
    })
  })
  karte.append(los)

  function zeichne(): void {
    anzahlReihe.replaceChildren()
    for (const n of [2, 3, 4]) {
      const k = el('button', 'wahl', `${n} Spieler`)
      k.setAttribute('aria-pressed', String(n === anzahl))
      k.addEventListener('click', () => {
        anzahl = n
        zeichne()
      })
      anzahlReihe.append(k)
    }

    limitReihe.replaceChildren()
    for (const [text, wert] of [
      ['bis zum Sieg', null],
      ['höchstens 150 Runden', 150],
      ['höchstens 300 Runden', 300],
    ] as const) {
      const k = el('button', 'wahl', text)
      k.setAttribute('aria-pressed', String(wert === limit))
      k.addEventListener('click', () => {
        limit = wert
        zeichne()
      })
      limitReihe.append(k)
    }

    liste.replaceChildren()
    for (let i = 0; i < anzahl; i++) {
      const zeile = el('div', 'mitspieler-zeile')
      const punkt = el('span', 'punkt')
      punkt.style.background = SPIELERFARBEN[i]!
      const eingabe = el('input')
      eingabe.value = namen[i]!
      eingabe.addEventListener('input', () => {
        namen[i] = eingabe.value.trim() || VORNAMEN[i]!
      })
      const schalter = el('button', 'wahl', bots[i] ? 'Bot' : 'Mensch')
      schalter.addEventListener('click', () => {
        bots[i] = !bots[i]
        zeichne()
      })
      zeile.append(punkt, eingabe, schalter)
      liste.append(zeile)
    }
  }

  zeichne()
}
